import React from 'react';
import {
  TransitionGroup,
  Transition as ReactTransition
} from 'react-transition-group';

interface IProps {
  location: {
    pathname: string;
    search: string;
    hash: string;
  };
}

/* interface ITransitionStyles {
    entering: {
        position: string;
        opacity: number;
    }
    entered: {
        transition: string;
        opacity: number;
    }
    
    exiting: {
        transition: string;
        opacity: number;
    }
} */

const timeout = 250;
const getTransitionStyles: any = {
  entering: {
    position: `absolute`,
    opacity: 0
  },
  entered: {
    transition: `opacity ${timeout}ms ease-in-out`,
    opacity: 1
  },
  exiting: {
    transition: `opacity ${timeout}ms ease-in-out`,
    opacity: 0
  },
  exited: {
    position: `absolute`,
    opacity: 0
  }
};

class Transition extends React.Component<IProps> {
  render() {
    const { children, location } = this.props;

    return (
      <TransitionGroup>
        <ReactTransition
          key={location.pathname}
          timeout={{
            enter: timeout,
            exit: timeout
          }}
        >
          {status => (
            <div
              style={{
                ...getTransitionStyles[status]
              }}
            >
              {children}
            </div>
          )}
        </ReactTransition>
      </TransitionGroup>
    );
  }
}

export default Transition;
